export default __webpack_public_path__ + "static/media/icon_home.704d6049.svg";